function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 1.782c-1.647 0-3.226.65-4.39 1.81A6.162 6.162 0 001.79 7.96c0 2.86 1.608 5.482 3.333 7.456A22.162 22.162 0 008 18.152a22.162 22.162 0 002.877-2.736c1.724-1.974 3.332-4.596 3.332-7.456 0-1.639-.654-3.21-1.819-4.369A6.225 6.225 0 008 1.782zM8 19.27l-.514.73-.003-.002-.005-.004-.019-.013a20.995 20.995 0 01-1.15-.904 23.946 23.946 0 01-2.537-2.492C1.945 14.495 0 11.462 0 7.96A7.94 7.94 0 012.343 2.33 8.02 8.02 0 018 0a8.02 8.02 0 015.657 2.331A7.94 7.94 0 0116 7.96c0 3.502-1.945 6.534-3.772 8.625a23.948 23.948 0 01-3.379 3.168 13.84 13.84 0 01-.308.228l-.019.013-.005.004-.002.001S8.514 20 8 19.27zm0 0l.514.73H7.486L8 19.27z",
  fill: "#211FAB"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 3.5,
  fill: "#211FAB"
});

function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgPin;